import { createContext, useContext, useReducer } from 'react';

const actionTypes = {
  UPDATE_DRAFT: 'UPDATE_DRAFT',
  DELETE_DRAFT: 'DELETE_DRAFT',
};

const initialState = {
  cid: null,
  text: null,
};

const ChatStateContext = createContext(initialState);

const ChatDispatchContext = createContext(null);

export function updateDraft(payload) {
  return { type: actionTypes.UPDATE_DRAFT, payload };
}

export function deleteDraft() {
  return { type: actionTypes.DELETE_DRAFT };
}

const chatDraftReducer = (state, { type, payload }) => {
  console.log({ state, type, payload });
  switch (type) {
    case 'UPDATE_DRAFT': {
      return { ...state, cid: payload.cid, text: payload.text };
    }
    case 'DELETE_DRAFT': {
      return initialState;
    }
    default:
      return state;
  }
};

export const ChatDraftProvider = ({ children }) => {
  const [state, defaultDispatch] = useReducer(chatDraftReducer, initialState);

  const dispatch = ({ type, payload }) => defaultDispatch({ type, payload });

  return (
    <ChatDispatchContext.Provider value={dispatch}>
      <ChatStateContext.Provider value={state}>
        {children}
      </ChatStateContext.Provider>
    </ChatDispatchContext.Provider>
  );
};

export const useChatDraftState = () => useContext(ChatStateContext);
export const useChatDraftDispatch = () => useContext(ChatDispatchContext);
